import { useEffect, useRef, useState } from "react";
import dynamic from "next/dynamic";

interface Props {
  closer: VoidFunction;
  isOpened: boolean;
  initialModal?: "signup" | "login";
  prefilledData?: {
    nameAndSurname?: string;
    email?: string;
  };
}

const SignUpModal = dynamic(() => import("../sign-up/SignUpModal"));
const LoginModal = dynamic(() => import("../login/LoginModal"));

export default function AuthModal({
                                    closer,
                                    isOpened,
                                    initialModal = "signup",
                                    prefilledData,
                                  }: Props) {
  const [activeModal, setActiveModal] = useState<"signup" | "login" | null>(
      null,
  );
  const isFirstRender = useRef(true);
  const isSwitchingModals = useRef(false);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (isOpened) {
      setActiveModal(initialModal);
    } else {
      setActiveModal(null);
    }
  }, [isOpened, initialModal]);

  const handleModalSwitch = (modalType: "signup" | "login") => {
    if (initialModal !== modalType) {
      isSwitchingModals.current = true;
    }
    setActiveModal(modalType);
  };

  const handleCloseModal = () => {
    if (!isSwitchingModals.current) {
      closer();
    }
    isSwitchingModals.current = false;
  };

  useEffect(() => {
  }, [prefilledData, isOpened]);

  return (
      <>
        {activeModal === "signup" && (
            <SignUpModal
                isOpened={true}
                closer={handleCloseModal}
                onSwitchToLogin={() => handleModalSwitch("login")}
                prefilledData={prefilledData}
            />
        )}

        {activeModal === "login" && (
            <LoginModal
                isOpened={true}
                closer={handleCloseModal}
                onSwitchToSignUp={() => handleModalSwitch("signup")}
            />
        )}
      </>
  );
}
